module.exports = __webpack_public_path__ + "img/robux.ba1db0d6.svg";